import * as React from 'react'

import { makeObservable, observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import DeliveryStatus, {
  formatStatusToDisplay,
} from '../../constants/DeliveryStatus'
import Delivery from '../../models/Delivery'
import { areObjectsEqual } from '../../utils/util'

interface IProps {
  delivery: Delivery
  status?: DeliveryStatus
  className?: string
  shouldAlignStatusToEnd?: boolean
}

@observer
export default class DeliveryStatusText extends React.Component<IProps> {
  @observable private delivery: Delivery = null
  public constructor(props: IProps) {
    super(props)
    this.delivery = props.delivery
    makeObservable(this)
  }

  public componentDidUpdate(): void {
    if (!areObjectsEqual(this.delivery, this.props.delivery)) {
      runInAction(() => {
        this.delivery = this.props.delivery
      })
    }
  }

  public render() {
    const { className, shouldAlignStatusToEnd } = this.props

    const {
      status,
      cancellationReason,
      isDenied,
      isDelivering,
      isPaused,
      isOnSite,
      isPending,
      isOnHold,
    } = this.delivery

    const deliveryStatus = formatStatusToDisplay(status, cancellationReason)
    const shouldInheritTextColor = !isDenied && !isPending && !isOnSite

    return (
      <div
        className={classList({
          [className]: !!className,
          'inherit-color': shouldInheritTextColor,
          'light-blue': isPending,
          yellow: isOnHold,
          orange: isOnSite || isDelivering,
          red: isDenied || isPaused,
          end: shouldAlignStatusToEnd,
        })}
        title={deliveryStatus}
      >
        {deliveryStatus}
      </div>
    )
  }
}
